import type { Habitat as HabitatKind } from "@eb/shared";
import { createDeepSea } from "./deepsea";
import { createJungle } from "./jungle";
import type { Habitat, HabitatOptions } from "./types";

export * from "./types";
export { createJungle } from "./jungle";
export { createDeepSea } from "./deepsea";
export { createNoise1D, createNoise2D, fbm1D, fbm2D } from "./noise";
export { AmbienceFollower } from "./common";

export function createHabitat(kind: HabitatKind, opts: HabitatOptions): Habitat {
  return kind === "deep_sea" ? createDeepSea(opts) : createJungle(opts);
}
